import Markdown from 'react-markdown';

export const MarketingHeader = ({ data }) => {
    return (
        <div className="marketing-header">
            <div className="flex-container">
                {data.bannerPhotoUrl && <div className='photo' style={{ backgroundImage: `url(${data.bannerPhotoUrl})` }}></div>}
                <div className="copy">
                    <h1 className="title">{data.displayTitle}</h1>
                    <Markdown>{data.displaySubtitle}</Markdown>
                </div>
            </div>
        </div>
    );
};
